import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantConstant } from '@app-constants/tenant.constant';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { allowedExamNamesCT, allowedMenuItems, apisDataCacheKeys, avatarImagesPath, examDisplayNames, homeRoute, secondNavigationLink, upperLeftsideNavigationMenu } from '@app-constants/app.constants';
import { AuthService } from '@app-services/auth-service/auth.service';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LoginService } from '@app-services/login/login.service';
import * as moment from 'moment';
import { FirebaseAnalyticsService } from '@app-services/firebase-analytics/firebase-analytics.service';
import { SelfLearnService } from '@app-services/self-learn/self-learn.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { environment } from '@app-environments/environment';
import { Observable, Subject } from 'rxjs';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
// import { examDisplayNamesMyActivity } from '@app-constants/app.constants';
import { clearLocalStorage, isUserAdmin } from '@app-helpers/functions';
import { ChatService } from '@app-core/chatwindow/chat.service';
import { ClassService } from 'src/app/core/services/class.service';
@Component({
  selector: 'app-sidebar-learn',
  templateUrl: './sidebar-learn.component.html',
  styleUrls: ['./sidebar-learn.component.css']
})
export class SidebarLearnComponent implements OnInit {
  mobMuenuStatus = false;
  public userType: number = 1;
  userData: any;
  targetexams: any = [];
  targetExam: any = '';
  selectedTab: any;
  tenant: any = TenantConstant.tenant;
  branch: any = TenantConstant.branch;
  portal: any = TenantConstant.portal;
  subscriptionList: any = [];
  profileImagePath = avatarImagesPath;
  profilePhoto: any;
  profilePic: boolean = false;
  eventSubscriber: Subscription = null;
  timeInterval: any=null;
  displayExamName: string;
  goalAddSuccess: boolean = false;
  userTotalsubscription:any;
  myActivityHide:any;
  selectedExamForMyActivity:any;
  hideActivity:boolean = true;
  showBookMarks:boolean = false;
  hideMyctivityBasedOnSubject = new Subject<any>();

  examnameChanged: Subscription;
  upperLeftsideNavigationMenu: any;
  secondNavigationLink: any;
  constructor(
    public router: Router,
    private testListService: TestlistService,
    private userService: UserService,
    public activatedRoute: ActivatedRoute,
    private _eventHandlingService: EventHandlingService,
    private gaService: GAnalyticsService,
    private _helper: HelperService,
    private authService: AuthService,
    private eventHandlingService: EventHandlingService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private loginService: LoginService,
    public navigationService: NavigationService,
    private selfLearnService: SelfLearnService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private _subscriptionService:SubscriptionService,
    private AchievementsService: MyactivityService,
    private chatService:ChatService,
    private classService: ClassService,
  ) {
    this.authService.photo.subscribe(pic => {
      if (pic) {
        this.profilePic = false;
        this.profilePhoto = pic
      } else {
        this.profilePic = true;
      }
    });

    this.AchievementsService.hideMyctivityBasedOnSubject.subscribe(res => {
     this.refreshMethod();
    });
    this.examnameChanged = this.testListService.examNameChange$.subscribe((value)=>{
      if(value){
        this.gradeBasedNavigations();
      }
    })
   }

  ngOnInit(): void {

    // this.selectedExamForMyActivity = 'FOUNDATIONTEST';

    this.myActivityHide = localStorage.getItem('targetExamName')
    if(this.myActivityHide == 'FOUNDATIONTEST' || this.myActivityHide=='APTITUDETEST' ){
        this.hideActivity = false;
    }


    this.testListService.getCurrentServerTime();
    let local = JSON.parse(localStorage.getItem('tabViewSelected'));
    if (local) {
      this.gaService.sendEvent('Course Category viewed', '', '', '', {
        event: 'Course Category viewed',
        'Category Id':
          this.selectedTab + '-' + local.targetExam.examId
            ? local.targetExam.examId
            : 2,
        'Navigated to which page': this.router.url,
        'Category Name':
          local.type + ' ' + local.targetExam.name
            ? local.targetExam.name
            : 'NEET',
      });
    }

    if (
      this.router.url.split('/').includes('liveclass')
    ) {
      localStorage.setItem('SelectedTab', 'liveclass');
      this.selectedTab = 'liveclass';
    } else if (
      this.tenant == 'infinitylearn' &&
      this.router.url?.indexOf('subscribedPackages') !== -1
    ) {
      localStorage.setItem('SelectedTab', 'subscribedPackages');
      this.selectedTab = 'subscribedPackages';
    } else {
      this.selectedTab = localStorage.getItem('SelectedTab') || 'assessment';
    }

    // this.setClassOnBody(this.selectedTab);

    this.loadUser();

    if (this.tenant != 'srichaitanya') {
      this.testListService.getSubscriptionDetails().then((resp: any) => {
        this.subscriptionList = resp;
      });
    }
    this.testListService.toLCFromASM.subscribe((data: any) => {
      this.moveTo('liveclass');
    });

    this.eventSubscriber = this.eventHandlingService.getChangeAction().subscribe(
      (item: any) => {
        if (item && item?.type == "updateProPic") {
          this.profilePhoto = this.userService.getUserProfileImg();
          if (this.profilePhoto) {
            this.profilePic = false;
          } else {
            this.profilePic = true;
          }
        }
      });
    this.gradeBasedNavigations();
   }

  refreshMethod(){
     // this.selectedExamForMyActivity = 'FOUNDATIONTEST';
     this.hideActivity = true;
     this.myActivityHide = localStorage.getItem('targetExamName')
     if(this.myActivityHide == 'FOUNDATIONTEST' || this.myActivityHide=='APTITUDETEST' ){
         this.hideActivity = false;
     }

  }


  mobBurgerMenuAction() {

    this.mobMuenuStatus = !this.mobMuenuStatus;
  }

  navigateTo(url: string, type: string) {
    let examName: any = localStorage.getItem('targetExamName');
    this.displayExamName = examDisplayNames[examName];
    let currentGrade = parseInt(this.userData.grade.name)
    localStorage.removeItem('logo-popup');
    localStorage.setItem('current-subscr-url', JSON.stringify(url));
    localStorage.setItem('SelectedTab', type);
    if( (currentGrade==1 ||  currentGrade==2) && this.displayExamName?.replace(' ','').toUpperCase() =='APTITUDETEST'){
      switch (type.toLowerCase()){
        case 'contactus':
          this.router.navigate(['/dashboard/contactus']);
          break;
        case 'invite_earn':
          this.router.navigate(['/dashboard/referral']);
          break;
        case 'selfLearn-V2':
          this.router.navigate(['/dashboard/selfLearn-V2']);
          break;
         default:
          this.router.navigate(['/dashboard/assessment']);
          break;
      }
    }else{
    this.router.navigate([url]);
    }
    this.bookmarksWindowViewed(type);
    if(type=='doubts'){
      this.chatService.setUserStatus(this.userData?.userId,{isOnline:true,name:this.userData?.firstName})

    }else if(type == "subscriptions"){
      this.navigateToSubscription()
    }
  }

  // navigateToLiveClass() {
  //   this.router.navigate(['/dashboard/liveclass'])
  // }

  // navigateToTest() {
  //   this.router.navigate(['/dashboard/testlist'])
  // }
  checkUserPkgs(){
    this._subscriptionService.getMySubscribedPackages('2'
    ).subscribe(
      (resp: any) => {
        this.userTotalsubscription = resp;


        // this.tabChange(); //? commenting code as its making the array []
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  navigateToSubscription() {
    localStorage.removeItem('logo-popup');
    this.firebaseAnalyticsService.postEvent("subscription_page_view");
    if (this.subscriptionList?.length > 0) {
      localStorage.setItem('SelectedTab', 'subscribedPackages');
      localStorage.setItem('current-subscr-url', '/dashboard/subscribedPackages');
      this.router.navigate(['/dashboard/subscribedPackages']);
    } else {
      localStorage.setItem('SelectedTab', 'subscriptionPackages');
      localStorage.setItem('current-subscr-url', '/subscription/subscriptionPackages');
      this.router.navigate(['/subscription/subscriptionPackages']);
    }
  }
  navigateToInviteAndEarn(){


    this.router.navigateByUrl('/dashboard/referral/')
  }

  loadUser(): void {
    this.userService.loadUserDetails().subscribe((data) => {
      const exams = data.exams || [];
      var a = exams.filter((v) => v.name == 'NEET');
      var b = exams.filter((v) => v.name != 'NEET');
      data.exams = [...a, ...b];
      if (!data?.exams?.length) {
        data.exams = [
          {
            description: 'National Eligibility and Entrance Test',
            image:
              'https://il-uiassets.s3.ap-south-1.amazonaws.com/uiassets/img/exams/neet-exam-logo.svg',
            examId: 2,
            name: 'NEET',
          },
        ];
      }
      this.userData = data;
      let targetExams = this.targetexams = data.exams;
      // debugger
      this.setExamType(targetExams);
      this.userType = this.userService.getUserType();
      this.profilePhoto = data.profilePhoto
      if (this.profilePhoto) {
        this.profilePic = false;
      } else {
        this.profilePic = true;
      }
    });
    this.displayExamName = localStorage.getItem('targetExamName');
  }

  setExamType(targetExams?: any) {

    let _selectExam: any = this.targetExam;

    let _findExam;
    if(_selectExam) {
      _findExam= targetExams.find(
        (x: any) => x.name?.replace(/\s/g,'').toUpperCase() == _selectExam?.replace(/\s/g,'').toUpperCase()
      );
    }
    if (!_findExam) {
      _findExam = targetExams[0];
      // localStorage.setItem(
      //   'targetExamName',
      //   (this.targetExam = _findExam.name
      //     ?.replaceAll(/\s/g, '')
      //     ?.toUpperCase())
      // );
    }

    if (this.selectedTab == 'liveclass') {
      let filter = {
        header: {
          'ot-exams': [`${_findExam?.name}`],
        },
      };

      this._eventHandlingService.changeAction({
        type: 'filter',
        dataType: 'all',
        filter: filter,
      });
    }
  }

  moveTo(type: any) {
    if (this.selectedTab != type) {
      localStorage.setItem('SelectedTab', type);
      this.selectedTab = localStorage.getItem('SelectedTab');
      this.router.navigate([`/dashboard/${type}`]);
      // this.setClassOnBody(this.selectedTab);
      if (type != 'subscribedPackages') {
        const exam = this.targetexams.find(
          (x: any) => x.name?.replace(/\s/g,'').toUpperCase() == this.targetExam?.replace(/\s/g,'').toUpperCase()
        );
        this.clickOnExam(exam || this.targetexams[0], type);
      }
    }
  }
  moveToSubscription() {
    this.selectedTab = 'subscribedPackages';
    localStorage.setItem('SelectedTab', 'subscribedPackages');
    // this.setClassOnBody(this.selectedTab);
    if (this.subscriptionList?.length) {
      this.router.navigate(['/dashboard/subscribedPackages']);
    } else {
      this.router.navigate(['/subscription/enroll']);
    }
  }

  clickOnExam(exam: any, type: any) {


    $('aside').removeClass('expend');

    // let selectedTab: any = {
    //   type: type,
    //   targetExam: exam,
    // };

    // localStorage.setItem('tabViewSelected', JSON.stringify(selectedTab));
    // let local = selectedTab;
    // this.gaService.sendEvent('Course Category viewed', '', '', '', {
    //   event: 'Course Category viewed',
    //   'Category Id':
    //     type + '-' + local.targetExam.examId ? local.targetExam.examId : 2,
    //   'Navigated to which page': this.router.url,
    //   'Category Name':
    //     local.type + ' ' + local.targetExam.name
    //       ? local.targetExam.name
    //       : 'NEET',
    // });

    let examName: any = exam?.name?.replaceAll(' ', '')?.toUpperCase();
    let obj = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    const userGrade = obj?.grade?.name?.replace(/[^0-9]/g,'');

    if (
      allowedExamNamesCT[userGrade].indexOf(examName) > -1
    ) {
      // localStorage.setItem('targetExamName', examName);

      this.targetExam = examName;
      if (type == 'liveclass') {
        let filter = {
          header: {
            'ot-exams': [`${exam.name}`],
          },
        };
        this._eventHandlingService.changeAction({
          type: 'filter',
          dataType: 'all',
          filter: filter,
        });
      } else {
        this.router.navigate(['/dashboard/assessment']);

        this.testListService.changeExamName(exam.name);
      }
    } else {
      this.targetExam = examName;
      this.router.navigate(['/dashboard/assessment/target-exam/', exam.name]);
    }
  }
  routeToSubscription() {
    this.router.navigate(['./dashboard/subscribedPackages']);
  }

  setDefaultPic() {
    // this.profilePhoto = "assets/img/empty-profile.svg";
    this.profilePic = false;
  }

  showMyProfile() : void {
    this.router.navigate(['myprofile']);
  }
  logout(): void {
    // this.addDailyGoal();
    isUserAdmin(this.userService)
    .then((bool)=>{
      if(bool) {
        this.classService.unSyncStudent()
        .toPromise()
        .then((e)=>{
          let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const data = {
      createDate: moment(new Date()).format('YYYY-MM-DD'),
      goalTime: JSON.parse(localStorage.getItem('setGoalTime')) || 0,
      spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
      userId: userData?.userId
    }
    this.userService.addDailyGoals(data).subscribe({next:(res: any) => {
      if (res) {
        const logoutMethod:any = this.tenant == 'srichaitanya' ? this.loginService.logoutSriChaitanya(): this.loginService.logout();
      logoutMethod.subscribe((res:any) => {
         ;
      }, (err:any) => {

      });
      let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
        if(user) {

      this.gaService.sendEvent(
        'User Logout',
        '',
        '',
        '',
        {
          'event': 'User Logout' ,
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': 'Pune',
          'Email ID': user.email,
          'Session Time': '1 hour',
          }

      );
        }
      this.testListService.clearApisData();
      this.closeinterval();

      clearLocalStorage();
      this.authService.updateAuthStatus(false);
      //uncomment below code when we're using router navigation
      // let cd = document.head.querySelectorAll("link.live-styles");
      // if(cd && cd.length) {
      //   for(let i =0; i < cd.length; i++) {
      //     document.head.removeChild(cd[i]);
      //   }
      // }
      this.spinner.show();
      window.location.href=homeRoute;

      //window.location.reload()
      }
    },error:(res: any) => {
      if (res) {
        const logoutMethod:any = this.tenant == 'srichaitanya' ? this.loginService.logoutSriChaitanya(): this.loginService.logout();
      logoutMethod.subscribe((res:any) => {
         ;
      }, (err:any) => {

      });
      let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
        if(user) {

      this.gaService.sendEvent(
        'User Logout',
        '',
        '',
        '',
        {
          'event': 'User Logout' ,
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': 'Pune',
          'Email ID': user.email,
          'Session Time': '1 hour',
          }

      );
        }
      this.testListService.clearApisData();
      this.closeinterval();

      clearLocalStorage();
      this.authService.updateAuthStatus(false);
      //uncomment below code when we're using router navigation
      // let cd = document.head.querySelectorAll("link.live-styles");
      // if(cd && cd.length) {
      //   for(let i =0; i < cd.length; i++) {
      //     document.head.removeChild(cd[i]);
      //   }
      // }
      this.spinner.show();
      window.location.href=homeRoute;

      //window.location.reload()
      }
    }})

        })
        .catch((err)=>{
          clearLocalStorage();
      this.authService.updateAuthStatus(false);
        })
      }else{
        let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const data = {
      createDate: moment(new Date()).format('YYYY-MM-DD'),
      goalTime: JSON.parse(localStorage.getItem('setGoalTime')) || 0,
      spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
      userId: userData?.userId
    }
    this.userService.addDailyGoals(data).subscribe({next:(res: any) => {
      if (res) {
        const logoutMethod:any = this.tenant == 'srichaitanya' ? this.loginService.logoutSriChaitanya(): this.loginService.logout();
      logoutMethod.subscribe((res:any) => {
         ;
      }, (err:any) => {

      });
      let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
        if(user) {

      this.gaService.sendEvent(
        'User Logout',
        '',
        '',
        '',
        {
          'event': 'User Logout' ,
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': 'Pune',
          'Email ID': user.email,
          'Session Time': '1 hour',
          }

      );
        }
      this.testListService.clearApisData();
      this.closeinterval();

      clearLocalStorage();
      this.authService.updateAuthStatus(false);
      //uncomment below code when we're using router navigation
      // let cd = document.head.querySelectorAll("link.live-styles");
      // if(cd && cd.length) {
      //   for(let i =0; i < cd.length; i++) {
      //     document.head.removeChild(cd[i]);
      //   }
      // }
      this.spinner.show();
      window.location.href=homeRoute;

      //window.location.reload()
      }
    },error:(res: any) => {
      if (res) {
        const logoutMethod:any = this.tenant == 'srichaitanya' ? this.loginService.logoutSriChaitanya(): this.loginService.logout();
      logoutMethod.subscribe((res:any) => {
         ;
      }, (err:any) => {

      });
      let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
        if(user) {

      this.gaService.sendEvent(
        'User Logout',
        '',
        '',
        '',
        {
          'event': 'User Logout' ,
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': 'Pune',
          'Email ID': user.email,
          'Session Time': '1 hour',
          }

      );
        }
      this.testListService.clearApisData();
      this.closeinterval();

      clearLocalStorage();
      this.authService.updateAuthStatus(false);
      //uncomment below code when we're using router navigation
      // let cd = document.head.querySelectorAll("link.live-styles");
      // if(cd && cd.length) {
      //   for(let i =0; i < cd.length; i++) {
      //     document.head.removeChild(cd[i]);
      //   }
      // }
      this.spinner.show();
      window.location.href=homeRoute;

      //window.location.reload()
      }
    }})

      }
    })
    .catch((err)=>{
      clearLocalStorage();
      this.authService.updateAuthStatus(false);
    })

  }

  // addDailyGoal() {
  //   let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
  //   const data = {
  //     createDate: moment(new Date()).format('YYYY-MM-DD'),
  //     goalTime: JSON.parse(localStorage.getItem('setGoalTime')),
  //     spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
  //     userId: userData?.userId
  //   }
  //   this.userService.addDailyGoals(data).subscribe((res: any) => {
  //
  //     if (res) {
  //       this.goalAddSuccess = true;
  //     }
  //   })
  // }

  closeinterval() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  }

  closeBurgerMenu() {
    this.mobMuenuStatus = false;
  }

  // Start of Fire base events

  bookmarksWindowViewed(type): any {
    if(type == 'mybookmarks'){
      this.bookmarksWindowViewedFBEvent()
    }
  }

  bookmarksWindowViewedFBEvent() {
    const objData = {
      ...this.selfLearnService.getUserInfo(),
      ...this.selfLearnService.getUserAcademics(),
      from_screen: this.navigationService.currentUrl
    };

    this.firebaseAnalyticsService.postEvent("bookmarks_window_viewed", objData);
  }

  // End of Fire base events
  gradeBasedNavigations() {
    this.upperLeftsideNavigationMenu =  upperLeftsideNavigationMenu.map(element => {
      element.active = this.checkUserAllowedMenu(element.module)
      return element
    }).filter(v => v.active);
    this.secondNavigationLink  = secondNavigationLink.map(element => {
      element.active = this.checkUserAllowedMenu(element.module)
      return element
    }).filter(v => v.active);
    upperLeftsideNavigationMenu.map(element => {
      if(element.module == 'selfLearnV2' && element.active == true){this.showBookMarks = true}
      else if(element.module == 'selfLearnV2' && element.active == false){this.showBookMarks = false}
    })
    let currentModule = this.router.url?.split('?')?.[0]?.split('/')?.[2];
    if(upperLeftsideNavigationMenu.some(v=>!v.active&& (v.module == currentModule )) || secondNavigationLink.some(v=>!v.active && (v.module == currentModule ))){
     this.router.navigate(['/dashboard'])
    }
  }
  checkUserAllowedMenu(menuitem) {
    const targetExamName = localStorage.getItem('targetExamName');
    let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const grade = userData?.grade?.name?.replace(/[^0-9]/g, '')
    return allowedMenuItems[grade][targetExamName].indexOf(menuitem) !== -1 ? true : false;
  }

  getSourceImage(tab:any){
    tab.allowedUrls.indexOf( this.router.url?.split('?')[0].split('/')[1]) !== -1 ? tab?.activeIcon :tab?.nonactiveIcon;
  }

  ngDestroy(){
    if(this.examnameChanged){
       this.examnameChanged.unsubscribe();
    }
  }
}
